/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const loopItemStatusAssignmentViewSchema = z.object({
  itemStatusIds: z.array(z.int()),
  portfolioDefaultItemStatusId: z.int().nullish(),
});
